import * as TYPES from '../mutation.types'

const state = {
    // userInfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}'),
    // token: sessionStorage.getItem('token') || '',
    loginUrl:''
}

const actions = {
    
}

const mutations = {
    // [TYPES.LOGIN]: (state, loginData) => {
    //     state.userInfo = loginData
    //     state.token = loginData.token
    //     sessionStorage.setItem('userInfo', JSON.stringify(loginData.user))
    //     sessionStorage.setItem('token', loginData.token)
    // },
    // [TYPES.LOGOUT]: state => {
    //     state.userInfo = {}
    //     state.token = ''
    //     sessionStorage.removeItem('userInfo')
    //     sessionStorage.removeItem('token')
    // },
    [TYPES.LOGINURL]:(state,url) => {
        state.loginUrl = url
    }
}

const getters = {
    getLoginUrl (state){
        return state.loginUrl
    },
}

export default {
    state,
    actions,
    mutations,
    getters
}





// WEBPACK FOOTER //
// ./src/store/modules/user.js